<template>
    <div>
        <div class="d-flex flex-column align-items-center" style="margin-top: 30px;">
            <div>
                <div class="row">
                    <div class="board-container">
                        <template v-if="cardsCompleted.length">
                            <img v-for="(url, index) in cardsCompleted" :key="'completed-' + index" :src="url"
                                :alt="'Completed Card ' + index" class="base-image" @click="showCompletedCardDetails(index)"/>
                        </template>
                        <template v-if="cardsCompleted.length < 6">
                            <img v-for="index in (6 - cardsCompleted.length) " :key="'backup-' + index"
                                src="/../img-version2/icons/mementogris.svg" alt="Backup Image" class="base-image" />
                        </template>
                    </div>

                    <div class="d-flex justify-content-end progress-container mt-2 mb-2">
                        <span>Parejas: <span style="color: #00B5F3;"> {{ counter }}/6</span></span>
                    </div>

                    <div class="progress-container position-relative">
                        <el-progress :percentage="progressPercentage" :color="progressColor" :stroke-width="12"
                            :show-text="false"></el-progress>
                        <div class="progress-dots">
                            <div v-for="(dot, index) in dotPositions" :key="index" :style="getDotStyle(dot)"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="game-board">
                <div v-for="(card, index) in cards" :key="index" class="card-game" :class="{ flipped: card.flipped, matched: card.matched }" @click="flipCard(index)">
                    <div class="card-game-inner">
                        <div class="card-game-front"><img src="/../img-version2/icons/mementodesktop.svg" alt="Imagen"></div>
                        <div class="card-game-back"><img :src="card.image.image" alt="Imagen" class="img-fluid"></div>
                    </div>
                </div>
            </div>

            <el-dialog :visible.sync="modalExit" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'" :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true" @close="handleClose" @before-close="handleBeforeClose" :center="true" class="custom-dialog">
                <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                    <img src="/../img-version2/icons/cup.svg" alt="Imagen" class="img-fluid">
                    <h5 class="mb-1 mt-3 text-title-bat" v-if="titleStatus">{{ titleStatus }}</h5>
                    <p class="text-bat" v-if="descriptionStatus">{{ descriptionStatus }}</p>
                    <el-button type="primary" @click="finishGame()" class="btn btnBlue">Aceptar</el-button>
                </div>
            </el-dialog>
        </div>

        <el-dialog :visible.sync="modalMatch" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'" :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true" :center="true" class="custom-dialog">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <img v-if="image" :src="image" alt="Imagen" class="img-fluid">
                <h5 class="mb-1 mt-3 text-title-bat" v-if="title">{{ title }}</h5>
                <p class="text-bat" v-if="description">{{ description }}</p>
                <el-button type="primary" @click="continueGame()" class="btn btnBlue">Aceptar</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="modalCardDetails" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'" :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true" :center="true" class="custom-dialog">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <img :src="selectedCardImage" alt="Imagen" class="img-fluid">
                <h5 class="mb-1 mt-3 text-title-bat">{{ selectedCardTitle }}</h5>
                <p class="text-bat">{{ selectedCardDescription }}</p>
                <el-button type="primary" @click="hideCardDetails()" class="btn btnBlue">Aceptar</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {

    props: {
        challenge_id: {
            default: '',
        },
    },
    data() {
        return {
            images: [],
            cards: [],
            firstCard: null,
            secondCard: null,
            lockBoard: false,

            title: '',
            description: '',
            image: '',
            cardsCompleted: [],

            counter: 0,
            titleStatus: '',
            descriptionStatus: '',

            modalMatch: false,
            modalExit: false,
            dotPositions: [30, 43, 57, 70],
            loading: false,
            modalCardDetails: false,
            selectedCardIndex: null,
            selectedCardTitle: '',
            selectedCardDescription: '',
            selectedCardImage: '',
        };
    },
    mounted() {
        this.getImages(this.challenge_id);
    },
    watch: {
        images() {
            this.initializeGame();
        },
    },
    computed: {
        progressPercentage() {
            return (this.cardsCompleted.length / 6) * 100;
        }
    },
    methods: {
        initializeGame() {
            this.cards = [...this.images, ...this.images]
                .sort(() => 0.5 - Math.random())
                .map(image => ({
                    image,
                    flipped: false,
                    matched: false,
                }));
        },
        getImages(challenge_id) {
            axios.get(`/retos/get-images-memento/${challenge_id}`)
                .then(response => {
                    this.images = response.data.images;
                })
                .catch(e => {
                    console.error('Error:', e);
                })
        },
        flipCard(index) {
            if (this.lockBoard || this.cards[index].flipped) return;

            this.cards[index].flipped = true;

            if (this.firstCard === null) {
                this.firstCard = index;
                return;
            }

            this.secondCard = index;
            this.lockBoard = true;

            if (this.cards[this.firstCard].image === this.cards[this.secondCard].image) {
                this.cards[this.firstCard].matched = true;
                this.cards[this.secondCard].matched = true;

                this.counter += 1;
                this.cardsCompleted.push(this.cards[this.firstCard].image.image);

                this.title = this.cards[this.firstCard].image.title;
                this.description = this.cards[this.firstCard].image.description;
                this.image = this.cards[this.firstCard].image.image;

                if (this.counter === 6) {
                    this.modalMatch = true;
                    this.waitForModalMatchClose().then(() => {
                        this.modalExit = true;
                        this.resetBoard();
                    });
                } else {
                    this.modalMatch = true;
                    this.resetBoard();
                }
            } else {
                this.title = '';
                this.description = '';
                this.image = '';

                setTimeout(() => {
                    this.cards[this.firstCard].flipped = false;
                    this.cards[this.secondCard].flipped = false;
                    this.resetBoard();
                }, 1000);
            }
        },
        resetBoard() {
            this.firstCard = null;
            this.secondCard = null;
            this.lockBoard = false;
        },
        continueGame() {
            this.modalMatch = false;
            this.title = '';
            this.description = '';
            this.image = '';

            if (this.counter === 6) {
                this.modalMatch = false;
                this.modalExit = true;
                this.titleStatus = '¡Felicitaciones!';
                this.descriptionStatus = 'completaste tu reto';
            }
        },
        finishGame() {
            if (this.loading) return; 

            this.loading = true; 

            let dataSend = {
                "challenge_id": this.challenge_id ? this.challenge_id : null,
            }

            axios.post('store', dataSend).then((response) => {
                let msgResponse = '';
                if (response.data.status === 'success') {

                    msgResponse = response.data.message
                    this.feedbackNotification('Reto Completado', msgResponse, 'success')
                    this.returnChallenge()
                } else {

                }
            }).then(() => {
                this.loading = false;
            });
        },
        returnChallenge() {
            window.location.href = '/retos?page=1&option=challenge';
        },
        feedbackNotification(title, message, type) {
            this.$notify({
                title: title,
                message: message,
                type: type
            });
        },
        waitForModalMatchClose() {
            return new Promise((resolve) => {
                const originalContinueGame = this.continueGame.bind(this);
                this.continueGame = () => {
                    originalContinueGame(); 
                    resolve(); 
                };
            });
        },
        getDotStyle(percentage) {
            const position = Math.min(Math.max(percentage, 0), 100) + '%';
            return {
                left: position,
                top: '50%',
                transform: 'translate(-50%, -50%)'
            };
        },
        progressColor() {
            if (this.progressPercentage === 0) {
                return '#dcdfe6';
            }
            return this.progressPercentage > 75 ? '#204F9A' : '#204F9A';
        },
        showCompletedCardDetails(index) {
            this.selectedCardIndex = index;
            const card = this.cards.find(card => card.image.image === this.cardsCompleted[index]);
            if (card) {
                this.selectedCardTitle = card.image.title;
                this.selectedCardDescription = card.image.description;
                this.selectedCardImage = card.image.image;
            }
            this.modalCardDetails = true;
        },
        hideCardDetails() {
            this.modalCardDetails = false;
            this.selectedCardIndex = null;
            this.selectedCardTitle = '';
            this.selectedCardDescription = '';
            this.selectedCardImage = '';
        },
        handleClose(done) {
            this.finishGame().then(() => {
                done(); 
            });
        },
        handleBeforeClose(done, type) {
            if (type === 'cancel') {
                this.finishGame().then(() => {
                    done();
                });
            } else {
                done(); 
            }
        }
    },
};
</script>
